import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Paper } from '@mui/material';
import { useStore } from '..';
import { handleDateChange } from '../helpers';
import { useAppSelector } from "@store/hooks";
import dayjs, { Dayjs } from 'dayjs';

const name = "CalendarSelectorElement";

const today = dayjs();
const future = dayjs().add(1, 'year');

const CalendarPickerElement: React.FC = () => {
    const [appointmentDate, , setAll] = useStore((store) => store['appointmentDate']);
    const restrictionExpiryIn30Days = useAppSelector(({ state }) => state.RestrictionExpiresIn30Days);
    const [minDate, setMinDate] = React.useState<Dayjs | undefined>(today);

    React.useEffect(() => {
        if (restrictionExpiryIn30Days > -1) {
            setMinDate(dayjs().add(restrictionExpiryIn30Days, 'day'));
        }
    }, [restrictionExpiryIn30Days]);

    const handleDateChangeInternal = (d: Dayjs | null) => {
        if (d) {
            setAll({ ...handleDateChange(d), emergencyOpen: false });
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Paper elevation={2} sx={{ p: 1 }}>
                <DateCalendar
                    openTo="day"
                    minDate={minDate}
                    maxDate={future}
                    onChange={handleDateChangeInternal}
                    value={dayjs(appointmentDate)}
                    views={['day']}
                    showDaysOutsideCurrentMonth
                />
            </Paper>
        </LocalizationProvider>
    );
};

CalendarPickerElement.displayName = name;

export default React.memo(CalendarPickerElement);
